import isEqual from 'lodash/isEqual';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearRecommendedPropertyAvailability,
  fetchRecommendedPropertyAvailability,
} from 'store/recommendedProperty/recommendedPropertyActions';
import { getQuery } from 'store/propertyAvailability/propertyAvailabilitySelectors';

const ResultsFetcher = () => {
  const dispatch = useDispatch();
  const query = useSelector(getQuery, isEqual);

  useEffect(() => {
    dispatch(fetchRecommendedPropertyAvailability());
    return () => {
      dispatch(clearRecommendedPropertyAvailability());
    };
  }, [dispatch, query]);

  return null;
};

export default ResultsFetcher;
